var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024pt",
    height: "1024pt",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 806.398438 308.480469 C 794.382812 296.363281 778.023438 289.550781 760.960938 289.550781 C 743.894531 289.550781 727.535156 296.363281 715.519531 308.480469 L 444.160156 579.839844 L 308.480469 444.160156 C 296.464844 432.042969 280.105469 425.230469 263.039062 425.230469 C 245.976562 425.230469 229.617188 432.042969 217.601562 444.160156 C 192.785156 469.121094 192.785156 509.4375 217.601562 534.398438 L 398.71875 715.519531 C 410.738281 727.636719 427.09375 734.449219 444.160156 734.449219 C 461.226562 734.449219 477.582031 727.636719 489.601562 715.519531 L 806.398438 398.71875 C 831.214844 373.757812 831.214844 333.441406 806.398438 308.480469 Z M 806.398438 308.480469 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a45f1658af84950134c81dc068f5c792.svg";
export { ForwardRef as ReactComponent };